module.exports = __webpack_public_path__ + "img/modify.9c3df123.svg";